import { Injectable } from '@angular/core';
import { FileService } from '../../shared/services/file.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { LogEvent } from './log-event.model';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import { SortDirection } from '../../shared/sort-direction';
import { LogEventSearchCriteria } from './log-event-search-criteria.model';
import { map, mergeMap } from 'rxjs/operators';
import * as moment from 'moment';


@Injectable()
export class LogEventService {

  private LOG_EVENTS_URI = 'logEvents';

  constructor(private http: HttpClient, private fileService: FileService) {
  }

  public getEvents(): Observable<string[]> {
    const headers = HttpUtils.createHeaders();

    const url = `${URL_BASE}/api/${this.LOG_EVENTS_URI}/events`;
    return this.http.get<string[]>(url, { headers });
  }

  public search(page: number, size: number, sortColumn: string, direction: SortDirection, criteria: LogEventSearchCriteria)
    : Observable<SearchObjectResult<LogEvent>> {
    if (criteria.start_date) {
      criteria.start_date = moment(criteria.start_date).utc(true).valueOf();
    }
    if (criteria.end_date) {
      criteria.end_date = moment(criteria.end_date).utc(true).valueOf();
    }
    if (criteria.event != null && criteria.event.length === 0) {
      criteria.event = null;
    }
    for (const key of Object.keys(criteria)) {
      if (!criteria[key]) {
        delete criteria[key];
      }
    }

    const headers = HttpUtils.createHeaders();
    const params  = {
      page: String(page),
      size: String(size),
      sort: sortColumn,
      direction: direction,
      ...criteria
    };
    const url     = `${URL_BASE}/api/${this.LOG_EVENTS_URI}/search`;
    return this.http.get(url, { headers, params })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, LogEvent.fromDto))
      );
  }

  public exportLogEvents(criteria: LogEventSearchCriteria, selectedColumns: string[]): Observable<void> {
    const url = `${URL_BASE}/api/${this.LOG_EVENTS_URI}/export`;

    const headers = HttpUtils.createHeaders();
    headers.set('Accept', 'text/plain');

    const params              = this.searchCriteriatToQueryParams(criteria);
    params["selectedColumns"] = selectedColumns;

    return this.http.get(url, { headers, params, responseType: 'blob', observe: 'response' })
      .pipe(
        mergeMap((response: HttpResponse<Blob>) => this.fileService.saveToFileSystem(response))
      );
  }

  private searchCriteriatToQueryParams(criteria: LogEventSearchCriteria) {
    const criteriaCopy = { ...criteria };

    for (const key of Object.keys(criteria)) {

      if (!criteriaCopy[key]) {
        delete criteria[key];
      }
    }

    return {
      ...criteria
    };
  }
}
